const Tick = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill=""
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7232 6.23741C15.0707 6.57449 15.0942 7.14584 14.7756 7.51356L9.40976 13.7071C9.25243 13.8887 9.03181 13.9944 8.79903 13.9998C8.56625 14.0051 8.3415 13.9097 8.17686 13.7355L5.25003 10.6387C4.91666 10.2859 4.91666 9.71406 5.25003 9.36133C5.5834 9.00859 6.12391 9.00859 6.45729 9.36133L8.75367 11.791L13.5171 6.2929C13.8356 5.92518 14.3756 5.90034 14.7232 6.23741Z"
      fill="white"
    />
  </svg>
);

export default Tick;
